import styles from "./GlobalModalComponent.module.scss";

interface ModalComponentProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
}

const GlobalModalComponent = ({
  children,
  isOpen,
  onClose,
  confirmText = "Təsdiq",
  cancelText = "Ləğv et",
}: ModalComponentProps) => {
  if (!isOpen) return null;

  return (
    <div className={styles.background} onClick={onClose}>
      <div
        className={styles.information_modal}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default GlobalModalComponent;
